module.exports = __webpack_public_path__ + "img/3E95CC_65D9F1_A2E2F6_679BD4-256px.b8acff82.png";